var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.job !== null)?_c('job-full',{attrs:{"job":this.job}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }